import { render, staticRenderFns } from "./SVGArrowLeft.vue?vue&type=template&id=5f43a689&scoped=true&"
import script from "./SVGArrowLeft.vue?vue&type=script&lang=js&"
export * from "./SVGArrowLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f43a689",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f43a689')) {
      api.createRecord('5f43a689', component.options)
    } else {
      api.reload('5f43a689', component.options)
    }
    module.hot.accept("./SVGArrowLeft.vue?vue&type=template&id=5f43a689&scoped=true&", function () {
      api.rerender('5f43a689', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGArrowLeft.vue"
export default component.exports